import { isInstanceOf, isTypeOrUndefined, isVertexKey, } from "./aux";
import { isShopTappingNodeData, } from "./graph";
import { getKeysOfObject, isArray, isAttachment, isBoolean, isNumber, isSheetMaterial, isString, isTubeCuttingParams, } from "./wsi4_typeguards";
export function isAttachments(entry) {
    const typeGuardMap = {
        attachments: (arg) => isArray(arg, isAttachment),
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isComment(entry) {
    const typeGuardMap = {
        comment: isString,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isCountersinking(entry) {
    const typeGuardMap = {
        numCounterSinks: isMultiplicity,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isFixedRotations(entry) {
    const typeGuardMap = {
        rotations: (arg) => isArray(arg, isNumber),
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isFlipSideUsage(entry) {
    const typeGuardMap = {
        flipSide: isBoolean,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isMaterialWithGas(entry) {
    const typeGuardMap = {
        material: isSheetMaterial,
        cuttingGasId: isString,
        invalid: isBoolean,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export var GrindingOption;
(function (GrindingOption) {
    GrindingOption["none"] = "none";
    GrindingOption["singleSidedMechanicalDeburring"] = "singleSidedMechanicalDeburring";
    GrindingOption["doubleSidedMechanicalDeburring"] = "doubleSidedMechanicalDeburring";
    GrindingOption["slideGrinding"] = "slideGrinding";
})(GrindingOption || (GrindingOption = {}));
export function isGrindingOption(t) {
    const map = {
        none: (arg) => arg === GrindingOption.none,
        singleSidedMechanicalDeburring: (arg) => arg === GrindingOption.singleSidedMechanicalDeburring,
        doubleSidedMechanicalDeburring: (arg) => arg === GrindingOption.doubleSidedMechanicalDeburring,
        slideGrinding: (arg) => arg === GrindingOption.slideGrinding,
    };
    for (const key of getKeysOfObject(map)) {
        if (map[key](t)) {
            return true;
        }
    }
    return false;
}
function isGrindingPrices(t) {
    const typeGuardMap = {
        none: isNumber,
        singleSidedMechanicalDeburring: isNumber,
        doubleSidedMechanicalDeburring: isNumber,
        slideGrinding: isNumber,
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isMechanicalGrinding(entry) {
    const typeGuardMap = {
        option: isGrindingOption,
        prices: isGrindingPrices,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isMultiplicity(t) {
    return isNumber(t) || t === "";
}
export function isTestReport(entry) {
    const typeGuardMap = {
        required: isBoolean,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isThickness(entry) {
    const typeGuardMap = {
        name: isString,
        invalid: (arg) => isTypeOrUndefined(arg, isString),
        number: isNumber,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isThreading(entry) {
    const typeGuardMap = {
        numThreads: isMultiplicity,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export const editDataValueMapTypeGuard = {
    articleExternalDrawingNumber: isString,
    articleExternalPartNumber: isString,
    articleExternalRevisionNumber: isString,
    articleName: isString,
    attachments: isAttachments,
    comment: isComment,
    countersinking: isCountersinking,
    fixedRotations: isFixedRotations,
    flipSideUsage: isFlipSideUsage,
    materialWithGas: isMaterialWithGas,
    mechanicalGrinding: isMechanicalGrinding,
    multiplicity: isMultiplicity,
    tapping: isShopTappingNodeData,
    testReport: isTestReport,
    thickness: isNumber,
    threading: isThreading,
    tubeDimX: isNumber,
    tubeCuttingData: isTubeCuttingParams,
};
export function isEditDataKey(t) {
    return getKeysOfObject(editDataValueMapTypeGuard)
        .some(key => key === t);
}
export function isRightEditValueType(key, t) {
    return editDataValueMapTypeGuard[key](t);
}
export function isEditDataValue(key, t) {
    return isRightEditValueType(key, t);
}
export function isEditData(t) {
    if (t === undefined) {
        return false;
    }
    if (typeof t !== "object") {
        return false;
    }
    if (t === null) {
        return false;
    }
    if (!("key" in t)) {
        return false;
    }
    const typeGuardMap = {
        key: isEditDataKey,
        vertexKey: isVertexKey,
        value: (a) => isEditDataValue(t.key, a),
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isArticleEditData(t) {
    return isArray(t, isEditData);
}
export function invalidMaterialWithGas(i18n) {
    return {
        material: {
            name: i18n.t("materialSelection"),
            description: i18n.t("invalidMaterial"),
            identifier: i18n.t("materialSelection"),
        },
        cuttingGasId: "",
        invalid: true,
    };
}
export function isAllowedAdditionalProcess(key, shopConfig) {
    const processesMap = {
        articleExternalDrawingNumber: [],
        articleExternalPartNumber: [],
        articleExternalRevisionNumber: [],
        articleName: [],
        attachments: [],
        comment: [],
        countersinking: ["countersinking"],
        fixedRotations: [],
        flipSideUsage: [],
        materialWithGas: [],
        mechanicalGrinding: [
            "mechanicalDeburring",
            "slideGrinding",
        ],
        multiplicity: [],
        tapping: ["tapping"],
        testReport: [],
        thickness: [],
        threading: ["threading"],
        tubeDimX: [],
        tubeCuttingData: [],
    };
    return shopConfig.allowedAdditionalProcesses.some(a => processesMap[key].some(p => p === a));
}
